function equal(value1, value2) {
    // If the types are different, they are not equal
    if (typeof value1 !== typeof value2) {
        return false;
    }
    // Handle specific types
    if (typeof value1 === 'object') {
        if (Array.isArray(value1) && Array.isArray(value2)) {
            // Compare arrays
            if (value1.length !== value2.length) {
                return false;
            }
            for (let i = 0; i < value1.length; i++) {
                if (!equal(value1[i], value2[i])) {
                    return false;
                }
            }
            return true;
        }
        else {
            // Compare objects
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) {
                return false;
            }
            for (const key of keys1) {
                if (!equal(value1[key], value2[key])) {
                    return false;
                }
            }
            return true;
        }
    }
    // For all other types (e.g., string, number)
    return value1 === value2;
}
export { equal };
